export function extractFileName(file, ext = false) {
  const fileParts = file.substr(file.lastIndexOf("/") + 1).split(".");
  return ext ? fileParts : fileParts.shift();
}
